import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function RegisterPage() {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email.trim()) setSubmitted(true);
  };

  return (
    <div style={s.page}>
      <div style={s.bgGlow} />
      <div style={s.card}>
        <Link to="/" style={s.backLink}>← Back</Link>
        <div style={s.logoWrap}>
          <img src="/logo_256.png" alt="Thankful Money" style={s.logo} />
        </div>
        <h1 style={s.title}>Request Access</h1>

        {!submitted ? (
          <>
            <p style={s.subtitle}>
              We're currently in private beta, refining signal accuracy and onboarding users in small batches.
            </p>
            <div style={s.betaBadge}>PRIVATE BETA</div>
            <form onSubmit={handleSubmit} style={s.form}>
              <input
                type="text"
                placeholder="Full name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                style={s.input}
              />
              <input
                type="email"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={s.input}
              />

              <button type="submit" style={s.btn}>Join Waitlist</button>
            </form>
            <p style={s.note}>
              We'll notify you when a spot opens. No spam, ever.
            </p>
          </>
        ) : (
          <div style={s.success}>
            <div style={s.checkmark}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M20 6L9 17l-5-5" stroke="#10b981" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h2 style={s.successTitle}>You're on the list</h2>
            <p style={s.successText}>
              We'll send an invite to <strong style={{color:'#f9fafb'}}>{email}</strong> once we open your cohort.
              We're currently onboarding in small batches to ensure platform stability.
            </p>
            <div style={s.timeline}>
              <div style={s.timelineDot} />
              <span style={s.timelineText}>Expected access: Q3 2026</span>
            </div>
          </div>
        )}

        <div style={s.divider} />
        <p style={s.footerText}>
          Already have an account? <Link to="/login" style={s.link}>Sign in</Link>
        </p>
      </div>
    </div>
  );
}

const s = {
  page: {
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    minHeight: '100vh', background: '#080d16', position: 'relative',
  },
  bgGlow: {
    position: 'absolute', top: '-100px', left: '50%', transform: 'translateX(-50%)',
    width: '800px', height: '400px',
    background: 'radial-gradient(ellipse at center, rgba(16,185,129,0.06) 0%, transparent 65%)',
    pointerEvents: 'none',
  },
  card: {
    width: 400, padding: '40px 36px', background: 'rgba(15,23,42,0.7)',
    borderRadius: 16, border: '1px solid #1e293b',
    textAlign: 'center', boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
    position: 'relative', zIndex: 1, backdropFilter: 'blur(8px)',
  },
  backLink: {
    position: 'absolute', top: 16, left: 20, fontSize: 12, color: '#6b7280',
    textDecoration: 'none', fontWeight: 500,
  },
  logoWrap: { marginBottom: 16 },
  logo: { width: 64, height: 64, objectFit: 'contain' },
  title: { fontSize: 24, fontWeight: 800, color: '#f9fafb', marginBottom: 8 },
  subtitle: { fontSize: 13, color: '#9ca3af', lineHeight: 1.6, marginBottom: 16 },
  betaBadge: {
    display: 'inline-block', fontSize: 10, fontWeight: 700, letterSpacing: 1.8,
    color: '#f59e0b', background: 'rgba(245,158,11,0.08)', border: '1px solid rgba(245,158,11,0.2)',
    padding: '5px 14px', borderRadius: 20, marginBottom: 24,
  },
  form: { display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 16 },
  input: {
    padding: '13px 16px', fontSize: 14, borderRadius: 8,
    border: '1px solid #1e293b', background: '#0f172a',
    color: '#f9fafb', outline: 'none', width: '100%', boxSizing: 'border-box',
  },
  btn: {
    padding: '14px 0', background: '#10b981', color: '#000',
    border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 700,
    cursor: 'pointer', marginTop: 4,
    boxShadow: '0 4px 16px rgba(16,185,129,0.2)',
  },
  note: { fontSize: 11, color: '#6b7280' },
  success: { padding: '24px 0' },
  checkmark: {
    width: 52, height: 52, borderRadius: '50%',
    background: 'rgba(16,185,129,0.08)', border: '1px solid rgba(16,185,129,0.25)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    margin: '0 auto 20px',
  },
  successTitle: { fontSize: 22, fontWeight: 700, color: '#f9fafb', marginBottom: 10 },
  successText: { fontSize: 13, color: '#9ca3af', lineHeight: 1.6, marginBottom: 20 },
  timeline: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 },
  timelineDot: { width: 8, height: 8, borderRadius: '50%', background: '#10b981' },
  timelineText: { fontSize: 12, color: '#6b7280', fontWeight: 500 },
  divider: { height: 1, background: '#1e293b', margin: '24px 0 16px' },
  footerText: { fontSize: 13, color: '#9ca3af' },
  link: { color: '#10b981', textDecoration: 'none', fontWeight: 600 },
};
